import { Component } from '@angular/core';
import { Icon } from '../icon';

@Component({
  selector: 'iconmonstr-magnifier',
  templateUrl: './magnifier.component.html',
})
export class MagnifierComponent extends Icon { }
